import State from '../utils/state';

const params = new URLSearchParams(window.location.search);

export default {
    computed: {
        postalCodeName () {
            return this.state.appRegion === 'us' ? 'Zip' : 'Postal';
        },

        canBookOnline () {
            if (this.state.appRegion === 'us') {
                return true;
            }

            return false;
        },

        hasSearchTypeParam () {
            return params.get('type') !== null;
        }

    },

    data () {
        return {
            state: State
        };
    }
};
